module.exports = __webpack_public_path__ + "img/Twitter_Logo_Blue.a7a925c7.svg";